module.exports = __webpack_public_path__ + "static/media/icons-sprite.643cb8a9.svg";